/* ════════════════════════════════════════════════════════════════════
   TRANSDERMA · French (fr) · Journal / blog page
   English is the source of truth in blog.html; this file supplies the
   French counterpart for each blog.* data-i18n key. Missing keys fall
   back to English automatically (see i18n.js).

   House voice: calm, exact, short. No em dashes (use periods, commas,
   or the mid-dot · ). Product names (Transderma C/A/O/M/R, Discovery
   Kit, Moisture Serum) stay in English. Informal singular "tu".
═════════════════════════════════════════════════════════════════════ */
(function(){
  window.TD_I18N = window.TD_I18N || {};
  window.TD_I18N.fr = window.TD_I18N.fr || {};
  Object.assign(window.TD_I18N.fr, {

    /* ── Footer · extra link not on the homepage ── */
    'footer.learn.about': 'À propos du Dr Ronlán',

    /* ── Page head ── */
    'blog.eyebrow': 'Journal',
    'blog.title': 'Notes du<br><em>laboratoire.</em>',
    'blog.intro': 'La science, les sérums et les rituels de soin chez Transderma : trente ans de recherche, traduits pour l\'étagère de la salle de bain.',

    /* ── Filter bar ── */
    'blog.filter.all': 'Tous',
    'blog.filter.science': 'Science',
    'blog.filter.ingredients': 'Ingrédients',
    'blog.filter.routines': 'Routines',
    'blog.filter.longevity': 'Longévité',

    /* ── Shared "Read" link ── */
    'blog.read': 'Lire <span class="arr">→</span>',

    /* ── Coming-soon labels (theme template; articles not yet live) ── */
    'blog.soon': 'Bientôt disponible',
    'blog.notice.upcoming': 'Les articles seront publiés bientôt · inscris-toi ci-dessous pour être notifié',

    /* ── Article 1 (featured) ── */
    'blog.a1.cat': 'Science',
    'blog.a1.time': '7 min de lecture',
    'blog.a1.date': 'Avr 2026',
    'blog.a1.title': 'Pourquoi les soins <em>sans eau</em> fonctionnent vraiment, et pourquoi la plupart des sérums non.',
    'blog.a1.excerpt': 'Entre soixante et quatre-vingt-dix pour cent du contenu d\'un flacon de sérum moyen est de l\'eau. Le reste : émulsifiants, épaississants et conservateurs. Quand nous disons que Transderma est sans eau, nous voulons dire que chaque goutte est formule active. Voici la chimie derrière ce choix, et pourquoi cela change ce qui atteint réellement la peau.',
    'blog.a1.read': 'Lire l\'article <span class="arr">→</span>',

    /* ── Article 2 ── */
    'blog.a2.cat': 'Ingrédients',
    'blog.a2.time': '5 min',
    'blog.a2.title': 'Palmitate de rétinyle contre rétinol : une voie plus douce vers le renouvellement.',
    'blog.a2.excerpt': 'Pourquoi Serum A utilise l\'ester palmitate de la vitamine A : comment il se convertit à l\'intérieur de la peau, pourquoi il est stabilisé avec la vitamine E, et à qui il convient le mieux.',

    /* ── Article 3 ── */
    'blog.a3.cat': 'Science',
    'blog.a3.time': '6 min',
    'blog.a3.title': 'La diffusion transdermique, expliquée pour l\'étagère de la salle de bain.',
    'blog.a3.excerpt': 'Ce que "au-delà du stratum corneum" signifie vraiment, comment le squalane transporte les vitamines actives à travers la couche externe de la peau, et la recherche en profondeur derrière le nom.',

    /* ── Article 4 ── */
    'blog.a4.cat': 'Routines',
    'blog.a4.time': '4 min',
    'blog.a4.title': 'Construis une routine Transderma en cinq étapes.',
    'blog.a4.excerpt': 'Matin, soir, ordre d\'application, et comment ajouter Serum M sans diluer l\'actif en dessous. Le rythme qui transforme cinq flacons en un système.',

    /* ── Article 5 ── */
    'blog.a5.cat': 'Longévité',
    'blog.a5.time': '8 min',
    'blog.a5.title': 'La question mitochondriale : pourquoi Serum O est le sérum de la longévité.',
    'blog.a5.excerpt': 'PQQ, créatine, vitamines B. L\'argument pour traiter le vieillissement cutané au niveau de l\'énergie cellulaire, et pourquoi le soutien mitochondrial est au cœur de la formule la plus distinctive de la gamme.',

    /* ── Article 6 ── */
    'blog.a6.cat': 'Ingrédients',
    'blog.a6.time': '5 min',
    'blog.a6.title': 'Resvératrol, picéide et la science derrière les marques post-acné.',
    'blog.a6.excerpt': 'Comment quatre ingrédients (et pas d\'eau) abordent le teint irrégulier, les dommages environnementaux et les marques qui persistent longtemps après la disparition du bouton.',

    /* ── Article 7 ── */
    'blog.a7.cat': 'Science',
    'blog.a7.time': '6 min',
    'blog.a7.title': 'Céramides, cholestérol et le mortier lipidique de la peau.',
    'blog.a7.excerpt': 'Pourquoi une barrière qui retient sa propre hydratation est l\'objectif, et comment Serum M complète les lipides que ta peau sait déjà fabriquer.',

    /* ── Article 8 ── */
    'blog.a8.cat': 'Routines',
    'blog.a8.time': '3 min',
    'blog.a8.title': 'Deux gouttes suffisent. L\'argument contre la surutilisation.',
    'blog.a8.excerpt': 'Un sérum concentré sans eau ne se comporte pas comme une crème hydratante à 65 % d\'eau. Pourquoi moins de matière va plus loin lorsque la formule travaille avec ta peau, non contre elle.',

    /* ── Newsletter ── */
    'blog.news.eyebrow': 'The Journal · Mensuel',
    'blog.news.title': 'Une courte lettre <em>chaque mois.</em>',
    'blog.news.body': 'Nouveaux articles, actualités produits discrètes et, de temps en temps, un mot du laboratoire. Pas de promotions, pas de remplissage. Une note réfléchie et un lien de désinscription dans chaque e-mail.',
    'blog.news.placeholder': 'ton@email.com',
    'blog.news.aria': 'Adresse e-mail',
    'blog.news.button': 'S\'abonner'

  });
})();
